export default function ConfigService($http, appSettings, $q, gettextCatalog) {
  'ngInject';
  return {
    //Gets all of the possible configurations for datapoints with the packages that you have access to
    getDatapointDisplayList: function () {
      var endpoint = appSettings.InReachApiEndpoint + '/config/display';

      return $http.get(endpoint);
    },
    getDatapointDisplayById: function (id) {
      if (!id) {
        var res = $q.defer();
        res.reject();
        return res.promise;
      }

      var endpoint = appSettings.InReachApiEndpoint + '/config/display/' + id;

      return $http.get(endpoint);
    },
    getDatapointDisplayForPackageAndModules: function (packageId, modulesIds) {
      if (!packageId) {
        let res = $q.defer();
        res.reject();
        return res.promise;
      }

      //validate that the module ids is a proper array
      if (!modulesIds || Object.prototype.toString.call(modulesIds) !== '[object Array]') {
        let res = $q.defer();
        res.reject();
        return res.promise;
      }

      var endpoint = appSettings.InReachApiEndpoint + '/config/display/?packageId=' + packageId;

      if (modulesIds && modulesIds.length > 0) {
        for (var i = 0; i < modulesIds.length; i++) {
          endpoint += 'moduleIds=' + modulesIds[i];
        }
      }

      return $http.get(endpoint);
    },
    createDatapointDisplayForPackageAndModules: function (packageId, modulesIds, dpd) {
      //Validated proper stuff parameters
      if (!packageId) {
        let res = $q.defer();
        res.reject();
        return res.promise;
      }

      //validate that the module ids is a proper array
      if (!modulesIds || Object.prototype.toString.call(modulesIds) !== '[object Array]') {
        let res = $q.defer();
        res.reject();
        return res.promise;
      }

      //Validate that the display items are specified
      if (!dpd || !dpd.displayItems) {
        let res = $q.defer();
        res.reject(gettextCatalog.getString('Please provide datapoint display items'));
        return res.promise;
      }

      var endpoint = appSettings.InReachApiEndpoint + '/config/display/?packageId=' + packageId;
      for (var i = 0; i < modulesIds.length; i++) {
        endpoint += '&moduleIds=' + modulesIds[i];
      }

      return $http.post(endpoint, dpd);
    },
    updateDatapointDisplay: function (dpd) {
      var endpoint = appSettings.InReachApiEndpoint + '/config/display/' + dpd.id + '/';

      return $http.put(endpoint, dpd);
    },
    deleteDatapointDisplayById: function (id) {
      if (!id) {
        let res = $q.defer();
        res.reject();
        return res.promise;
      }

      var endpoint = appSettings.InReachApiEndpoint + '/config/display/' + id;

      return $http.delete(endpoint);
    }
  };
}